import { render, staticRenderFns } from "./RemoveAccount.vue?vue&type=template&id=5c3f92b4&"
import script from "./RemoveAccount.vue?vue&type=script&lang=js&"
export * from "./RemoveAccount.vue?vue&type=script&lang=js&"
import style0 from "./RemoveAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports